module.exports = __webpack_public_path__ + "static/media/footerkw.c0331b5f.png";